module.exports = __webpack_public_path__ + "img/lk-menu-cancel.517cfebf.svg";